import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/* CSS */
import styles from './TripCard.module.css';

/* Context menu */
import TripContextMenu from './TripContextMenu';

/* Utils */
import { formatDateRange } from '../../utils/dateUtils';
import { getCountryImage } from '../../utils/countryUtils';

/* Icons */
import three_dot from '../../assets/icons/three_dot.svg';

const TripCard = ({ trip, className = "", onDelete, onDuplicate }) => {

    const navigate = useNavigate();

    const [menuPosition, setMenuPosition] = useState(null);
    const menuButtonRef = useRef(null);

    const toggleMenu = (e) => {
        e.stopPropagation();

        if (menuPosition) {
            setMenuPosition(null);
            return;
        }

        if (menuButtonRef.current) {
            const rect = menuButtonRef.current.getBoundingClientRect();
            const menuHeight = 140;
            const menuWidth = 160;

            let top = rect.bottom + 4;
            let left = rect.right - menuWidth;

            if (window.innerHeight - rect.bottom < menuHeight) {
                top = rect.top - menuHeight - 4;
            }

            setMenuPosition({ x: left, y: top });
        }
    };

    const firstLocation = trip.locations && trip.locations.length > 0 ? trip.locations[0] : null;
    const coverImage = getCountryImage(firstLocation);

    return (
        <>
            <article className={`${styles.tripCard} ${className}`}>
                <p className={styles.title} title={trip.title}>{trip.title}</p>
                <p className={styles.date}>{formatDateRange(trip.fromDate, trip.toDate)}</p>

                <img
                    src={coverImage}
                    alt='Trip card'
                    className={styles.image}
                    loading="lazy"
                    decoding="async"
                />

                <div className={styles.actions}>
                    <button className={styles.primaryButton} onClick={(e) => { e.stopPropagation(); navigate(`/trip/${trip.id}`) }}>
                        Open trip
                    </button>

                    <div className={styles.menuWrapper}>
                        <button
                            ref={menuButtonRef}
                            className={`${styles.threeDotButton} ${menuPosition ? styles.active : ''}`}
                            onClick={toggleMenu}
                        >
                            <img src={three_dot} alt='Trip card options' className={styles.threeDot} />
                        </button>
                    </div>
                </div>
            </article>

            {menuPosition && (
                <TripContextMenu
                    trip={trip}
                    position={menuPosition}
                    triggerRef={menuButtonRef}
                    onClose={() => setMenuPosition(null)}
                    onDuplicate={onDuplicate}
                    onDelete={onDelete}
                />
            )}
        </>
    );
};

export default TripCard;
